module.exports = __webpack_public_path__ + "img/Contents.c008c842.jpg";